module.exports = __webpack_public_path__ + "img/rebecca-mills-little-help.a8a424d.jpg";